import { render, staticRenderFns } from "./SelectionCardRadio.vue?vue&type=template&id=6d4d9894&"
import script from "./SelectionCardRadio.vue?vue&type=script&lang=ts&"
export * from "./SelectionCardRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports